import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { POST_PAY_NOW_PROXY_DETAILS_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import { IExamMasterCodeItem } from '../../api/user/model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

interface GenericMobileNo {
  countryCode: IExamMasterCodeItem;
  number: string;
}

export interface PayNowProxyRequestBody {
  uuid: string;
  payload: {
    name: string;
    uinfin: string | undefined;
    confirmUinfin: string | undefined;
    mobileNumber: GenericMobileNo | undefined;
    confirmMobileNumber: GenericMobileNo | undefined;
  };
}

export const usePostPayNowProxyDetails = ({ onSuccess, onError }: Input) => {
  const postPayNowProxyDetails = async (payNowProxyRequest: PayNowProxyRequestBody) => {
    await axiosClient.post<void>(
      POST_PAY_NOW_PROXY_DETAILS_URL(payNowProxyRequest.uuid),
      payNowProxyRequest.payload
    );
  };

  return useCustomMutation(postPayNowProxyDetails, {
    onSuccess,
    onError,
  });
};
